import functions from '../functions';
import { list } from './list';

$(() => {
    listTravel.init();
});

const listTravel = {
    $form: null,
    form: null,
    $filter: null,
    filter: null,
    defaults: {
        _page: 1,
        perPage: 12,
        language: functions.getLang(),
        arrivalDateFrom: '',
        destination: '',
        countryId: '',
        objectGroupId: 6,
        guests: '2,0,0',
        hasArrival: 4,
        hasDiscount: null
    },
    params: {},
    isHome: false,
    $listItems: null,
    filterParams: {
        tagCategoryId: null,
        sortBy: null, 
        objectName: null,
    },
    mainFields: ['arrivalDateFrom', 'destination', 'sortBy', '_page'],
    init() {
        this.$form = $('.search-form.search-travel');
        this.form = this.$form[0];

        if( ! this.form) {
            return;
        }

        this.$listItems = $('.list-items');
        this.isHome = this.$form.attr('data-ishome');

        if(this.$form.attr('data-tagcategoryid')) {
            $('[name="tagCategoryId"][data-value="' + this.$form.attr('data-tagcategoryid') + '"]').attr('checked', true);
        }

        this.$form.on('submit', e => {
            const $target = $(e.target);
            e.preventDefault();

            let params = functions.getFormData($target);
            if( ! params.dates) {
                params.dateFrom = params.dateTo = null;
            }

            params._page = 1;
            if(this.isHome) {
                params = functions.cleanParams(params);
                location = $(e.target).find('[data-listurl]').attr('data-listurl') + '#' + $.param(params);
            } else {
                functions.setUrlData(params, true, true);
            }
        });

        this.getParams();
        functions.setFormData(this.form, this.params);
        this.params.guests = $('[name=guests]').val();
        this.find(this.params);

        $('.ms-clear').on('click', e => {
            e.preventDefault();
            e.stopPropagation();
            this.params.destination = '';
            $(this.form.destination).val('').trigger('change');
        });

        $(window).on('hashchange', e => {
            this.getParams();
            this.setTagCategoryId();
            this.stopChangeEvents = true;

            functions.scrollToElement(this.$listItems, 100);
            this.find(this.params);
            this.stopChangeEvents = false;
        });

        $('[name="tagCategoryId"]').on('change', e => {
            this.params._page = this.defaults._page;
            this.setTagCategoryId();
            this.getParams();
            this.find(this.params);
        });
    },
    getParams() {      
        this.params = list.getParams(this.params, this.defaults, this.filterParams);

        if(this.params.arrivalDateFrom) {
            
            let dateFrom = new Date(this.params.arrivalDateFrom);
            let month = dateFrom.getMonth() + 1;
            
            let lastDateOfMonth = new Date(dateFrom.getFullYear(), month, 0);
            this.params.arrivalDateTo = lastDateOfMonth.getFullYear() + '-' + (lastDateOfMonth.getMonth() + 1) + '-' + lastDateOfMonth.getDate();
        }
    },
    setTagCategoryId() {
        let tagCategoryIds = [];
        $('[name="tagCategoryId"]').each((index, target) => {
            const $target = $(target);
            if($target[0].checked) {
                tagCategoryIds.push($target.attr('data-value'));
            }
        });

        this.filterParams.tagCategoryId = tagCategoryIds.join(",");
    },
    find(params) {
        list.find(params).then((response) => {
            list.findDone(response);
            // LOZAD
            window.observer.observe();
        });
    },

};